import { useCallback } from 'react'
import { useForm } from '../providers/FormProvider'
import { WorkPostSheetItemTypesEnum } from '../types'

// Returns a function that finds the index of an item in `values.items`, used to build Formik field names.
export function useWPSItemIndex(): (
  name: WorkPostSheetItemTypesEnum
) => number {
  const { values } = useForm()

  return useCallback(
    (name: WorkPostSheetItemTypesEnum) =>
      values.items.findIndex(item => item.name === name),
    [values.items]
  )
}
